import { v4 as uuid } from "uuid";

import { useRequire as loadFile } from "../../_utils";

import audio1 from "../../assets/files/audio/dark-future-logo-196217.mp3";
import audio2 from "../../assets/files/audio/inspiring-trailer-15-sec-203615.mp3";

const iconMapping = {
  business: "MdBusiness",
  code: "MdCode",
  sell: "MdSell",
  people: "MdPeople",
  money: "MdAttachMoney",
  support: "MdSupport",
};

export default {
    users: [],
    devices: [],
    platforms: [],
    dealers: [],
    deployments: [],
    accessLogs: []
};
